import './styles.scss';

const ConfettiBar = () => (
  <div className="energy-tariff-modal__confetti-bar" data-testid="confetti-bar">
    <div />
    <div />
    <div />
  </div>
);

export { ConfettiBar };
